/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".pending-invitation-dialog-form[_ngcontent-%COMP%]{overflow-y:scroll}.pending-invitation-dialog[_ngcontent-%COMP%]   .invitation-list-item[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;padding:10px}.pending-invitation-dialog[_ngcontent-%COMP%]   .invitation-list-item[_ngcontent-%COMP%]   .invitation-buttons[_ngcontent-%COMP%]{display:flex;justify-content:space-around;align-items:center}.pending-invitation-dialog[_ngcontent-%COMP%]   .invitation-list-item[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-left:20px}"];
export { styles as styles };

